import React, { useEffect } from 'react';
import { Form } from '@rocketseat/unform';
import { useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { Title, WrapperFlex } from '@unimed-fesp/components';

import { Creators as ListaActions } from '../../store/ducks/lista';

import history from '../../services/history';

import { Container } from './styles';
import theme from '../../styles/theme';

import FadeIn from '../../components/atoms/FadeIn';
import LoadingSpinning from '../../components/molecules/LoadingSpinning';
import FormListaInativos from './FormListaInativos';

function ListaInativo() {
  const { idLista } = useParams();

  const {
    loading,
    success,
    details,
    response: { listaInativos },
  } = useSelector((state) => state.lista);
  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(ListaActions.getListaInativasRequest(idLista));
  }, [dispatch, idLista]);

  useEffect(() => {
    const HAS_MODALIDADE = !!listaInativos?.nrCodigoModalidade;

    if (HAS_MODALIDADE || (!loading && success && details))
      history.push(`/novo/listainativo/${idLista}/detalhe`);
  }, [details, idLista, listaInativos?.nrCodigoModalidade, loading, success]);

  function handleSubmit(data) {
    const request = {
      idLista: listaInativos?.nmLista,
      modalidade: data.modalidade,
      descricao: data.descricao,
    };
    dispatch(ListaActions.putListaInativasRequest(request));
  }

  if (loading)
    return (
      <WrapperFlex fullWidth alignCenter justifyCenter minHeight={400}>
        <FadeIn>
          <LoadingSpinning />
        </FadeIn>
      </WrapperFlex>
    );

  return (
    <Container>
      <FadeIn>
        <Title
          text="lista inativos"
          color={theme.titleGray}
          fontSize={38}
          marginBottom={8}
        />
        <Form onSubmit={handleSubmit}>
          <FormListaInativos lista={listaInativos} />
        </Form>
      </FadeIn>
    </Container>
  );
}

export default ListaInativo;
